import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Signin.css";
import logo from "../../components/logo.png";

function Signin() {
  const navigate = useNavigate();

  // State for form inputs
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  // State for UI feedback
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const { email, password } = formData;

    // Basic validation
    if (!email || !password) {
      setError("All fields are required!");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        "https://nesthub-server.vercel.app/api/member/signin",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();
      console.log(data);

      if (!response.ok) {
        throw new Error(data.message || "Invalid credentials.");
      }

      // Save token and user data
      localStorage.setItem("memberId", data.member._id);

      // Redirect to dashboard
      if (data.member.verified) {
        navigate("/dashboard");
      } else {
        navigate("/cashout/50");
      }
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin">
      <div className="signin_logo">
        <img src={logo} alt="" />
      </div>
      <h2>Carolina Sauce Methods</h2>
      <h1>SIGN IN</h1>
      <small>Please enter valid credentials below.</small>

      {error && <p className="error-message">{error}</p>}
      {loading && <p className="loading-message">Logging in...</p>}

      <form className="form" onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>

      <p>
        Don't have an account? <a href="/signup">Sign up</a>
      </p>
      <div className="back">
        <a href="/">Back to Home</a>
      </div>
    </div>
  );
}

export default Signin;
